"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
angular.module('app', ['ngAnimate', 'ngMessages', 'ngSanitize', 'monospaced.elastic', 'ui.bootstrap.modal', 'ui.bootstrap.dropdown',
// 'ui.bootstrap.tabs',
'uib/template/modal/window.html',
// 'uib/template/tabs/tab.html',
// 'uib/template/tabs/tabset.html',
'ui.router']).constant('$env', {
  API: '/api/v3'
}).config(function ($urlRouterProvider, $urlMatcherFactoryProvider, $httpProvider, $sceDelegateProvider) {
  $urlRouterProvider.otherwise('/');

  // make a trailing slashe optional
  $urlMatcherFactoryProvider.strictMode(false);
  $httpProvider.interceptors.push('authInterceptor');
  $sceDelegateProvider.resourceUrlWhitelist(['self']);
}).run(function ($rootScope, $state, $transitions, $window, $dialog) {
  $rootScope.$state = $state;
  $rootScope.$on('AUTH_REQUIRED', function (event) {
    event.preventDefault();
    $window.location.href = '/login';
  });
  $transitions.onError({}, function (transition) {
    var error = transition.error();
    if (error.detail && error.detail.status) {
      if (error.detail.status !== 401) {
        $dialog.error('Whoops, looks like something went wrong.');
      }
    }
  });
});
angular.module('app').directive('googlePlace', function () {
  return {
    restrict: 'A',
    scope: {
      ngModel: '=',
      place: '=googlePlace',
      options: '=?',
      onPlaceChanged: '&',
      attachToElement: '@'
    },
    link: function link(scope, element, attrs) {
      // Australia's bounds
      var bounds = new google.maps.LatLngBounds(new google.maps.LatLng(-44.156943, 112.373678), new google.maps.LatLng(-10.193732, 153.930143));
      var autocomplete = new google.maps.places.Autocomplete(element[0], _objectSpread({
        bounds: bounds
      }, scope.options));
      if (scope.attachToElement === 'true') {
        element.on('focus', function () {
          $(element.parent()).append($('.pac-container'));
        });
      }
      autocomplete.addListener('place_changed', function () {
        var place = autocomplete.getPlace();
        scope.$apply(function () {
          scope.ngModel = element.val();
          scope.place = {
            name: scope.ngModel
          };
          if (place.address_components) {
            scope.place.address_components = place.address_components;
          }
          if (place.geometry && place.geometry.location) {
            scope.place.geometry = {
              location: place.geometry.location
            };
          }
        });
        scope.onPlaceChanged({
          place: place
        });
      });
      element.on('focus', function () {
        element.attr('autocomplete', element.attr('name'));
      });
    }
  };
});
angular.module('app').directive('keepScrollPos', function ($window, $timeout, $state, $transitions) {
  var scrollPosCache = {};
  return {
    link: function link(scope) {
      $transitions.onStart({}, function (transition) {
        var from = transition.from();
        if (from.data && from.data.keepScrollPos) {
          var url = $state.href(from.name, transition.params('from'));
          var scrollPos = {
            x: $window.pageXOffset,
            y: $window.pageYOffset
          };
          console.log(url, scrollPos);
          scrollPosCache[url] = scrollPos;
        }
      });
      $transitions.onFinish({}, function (transition) {
        var to = transition.to();
        var scrollPos = {
          x: 0,
          y: 0
        };
        if (to.data && to.data.keepScrollPos) {
          var url = $state.href(to.name, transition.params('to'));
          scrollPos = scrollPosCache[url] || {
            x: 0,
            y: 0
          };
        }
        $timeout(function () {
          console.log('Scroll to', scrollPos.x, scrollPos.y);
          $window.scrollTo(scrollPos.x, scrollPos.y);
        }, 0);
      });
      scope.$on('SCROLL', function () {
        var url = $state.href($state.current.name, $state.params);
        var scrollPos = scrollPosCache[url] || {
          x: 0,
          y: 0
        };
        $timeout(function () {
          console.log('Scroll to', scrollPos.x, scrollPos.y);
          $window.scrollTo(scrollPos.x, scrollPos.y);
        }, 0);
      });
    }
  };
});
angular.module('app').directive('ngMatch', function ($parse) {
  return {
    require: 'ngModel',
    link: function link(scope, element, attrs, controller) {
      controller.$validators.match = function (modelValue) {
        return modelValue === $parse(attrs.ngMatch)(scope);
      };
      scope.$watch(attrs.match, function () {
        controller.$validate();
      });
    }
  };
});
angular.module('app').directive('order', function (appCacheFactory) {
  return {
    restrict: 'A',
    scope: {
      order: '=',
      onOrder: '&'
    },
    link: function link(scope, element, attrs) {
      element.css({
        cursor: 'pointer'
      });
      element.on('click', function () {
        scope.$apply(function () {
          if (scope.order.by === attrs.orderBy) {
            // toggle "how"
            scope.order.how = {
              asc: 'desc',
              desc: 'asc'
            }[scope.order.how];
          } else {
            scope.order.by = attrs.orderBy;
          }
          scope.onOrder(); // callback
        });
        if (scope.order.key) {
          appCacheFactory.put(scope.order.key, scope.order);
        }
      });
      function setClass() {
        element.removeClass('sorted-asc sorted-desc');
        if (scope.order.by === attrs.orderBy) {
          element.addClass({
            asc: 'sorted-asc',
            desc: 'sorted-desc'
          }[scope.order.how]);
        }
      }
      scope.$watch(function () {
        return scope.order;
      }, function () {
        setClass();
      }, true);
    }
  };
});
angular.module('app').directive('pagination', function () {
  return {
    restrict: 'A',
    template: "\n        <li class=\"page-item\" ng-repeat=\"page in pages\" ng-class=\"{ active: page.active, disabled: page.page === null }\">\n          <a href class=\"page-link\" ng-click=\"onPageSelect(page)\" ng-bind-html=\"::page.label\"></a>\n        </li>",
    scope: {
      page: '=',
      numOfPages: '=',
      onPageSelect: '&'
    },
    link: function link(scope) {
      function getPages(page, numOfPages) {
        if (!page || !numOfPages) {
          return [];
        }
        var i;
        var pages = [];
        pages.push({
          label: '<span class="mdi mdi-arrow-left"></span>',
          page: page > 1 ? page - 1 : null
        });
        if (numOfPages <= 9) {
          for (i = 1; i <= numOfPages; i += 1) {
            pages.push({
              label: i,
              page: i,
              active: i === page
            });
          }
        } else if (page <= 5) {
          // 1 2 3 4 5 6 7 ... 15

          for (i = 1; i <= 7; i += 1) {
            pages.push({
              label: i,
              page: i,
              active: i === page
            });
          }
          pages.push({
            label: '...'
          }, {
            label: numOfPages,
            page: numOfPages
          });
        } else if (page < numOfPages - 4) {
          // 1 ... 4 5 6 7 8 ... 15

          pages.push({
            label: 1,
            page: 1
          }, {
            label: '...'
          });
          for (i = page - 2; i <= page + 2; i += 1) {
            pages.push({
              label: i,
              page: i,
              active: i === page
            });
          }
          pages.push({
            label: '...'
          }, {
            label: numOfPages,
            page: numOfPages
          });
        } else {
          // 1 ... 9 10 11 12 13 14 15

          pages.push({
            label: 1,
            page: 1
          }, {
            label: '...'
          });
          for (i = numOfPages - 6; i <= numOfPages; i += 1) {
            pages.push({
              label: i,
              page: i,
              active: i === page
            });
          }
        }
        pages.push({
          label: '<span class="mdi mdi-arrow-right"></span>',
          page: page < numOfPages ? page + 1 : null
        });
        return pages;
      }
      scope.$watch('page', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          scope.pages = getPages(newValue, scope.numOfPages);
          console.log('page:', newValue);
        }
      });
      scope.$watch('numOfPages', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          scope.pages = getPages(scope.page, newValue);
          console.log('numOfPages:', newValue);
        }
      });
      scope.pages = getPages(scope.page, scope.numOfPages);
    }
  };
});
angular.module('app').directive('passwordLetters', function () {
  return {
    require: 'ngModel',
    link: function link(scope, element, attrs, controller) {
      controller.$validators.passwordLetters = function (modelValue) {
        if (!modelValue) {
          return true;
        }
        var uppercaseRegex = /[A-Z]/g;
        var lowercaseRegex = /[a-z]/g;
        var ucLetters = modelValue.match(uppercaseRegex);
        var lcLetters = modelValue.match(lowercaseRegex);
        return !!ucLetters && ucLetters.length > 0 && !!lcLetters && lcLetters.length > 0;
      };
    }
  };
});
angular.module('app').directive('passwordNumerals', function () {
  return {
    require: 'ngModel',
    link: function link(scope, element, attrs, controller) {
      controller.$validators.passwordNumerals = function (modelValue) {
        if (!modelValue) {
          return true;
        }
        var numeralsRegex = /[0-9]/g;
        var numerals = modelValue.match(numeralsRegex);
        return !!numerals && numerals.length > 0;
      };
    }
  };
});
angular.module('app').directive('passwordSymbols', function () {
  return {
    require: 'ngModel',
    link: function link(scope, element, attrs, controller) {
      controller.$validators.passwordSymbols = function (modelValue) {
        if (!modelValue) {
          return true;
        }
        var lettersAndNumeralsRegex = /[A-Za-z0-9]/g;
        var lettersAndNumerals = modelValue.match(lettersAndNumeralsRegex);
        return !!lettersAndNumerals && lettersAndNumerals.length > 0 && lettersAndNumerals.length < modelValue.length;
      };
    }
  };
});
angular.module('app').directive('randomName', function () {
  return {
    restrict: 'A',
    scope: {
      n: '=randomName'
    },
    link: function link(scope, element) {
      function createRandomName() {
        var dt = new Date().getTime();
        return 'rn' + 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          var r = (dt + Math.random() * 16) % 16 | 0;
          dt = Math.floor(dt / 16);
          return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
        });
      }
      ;
      if (!scope.n) {
        scope.n = createRandomName();
      }
    }
  };
});
angular.module('app').directive('slideDown', function ($timeout) {
  return {
    restrict: 'A',
    scope: {
      expanded: '=slideDown'
    },
    transclude: true,
    link: function link(scope, element, attrs) {
      var elementScope = element.scope();
      var lazyRender = attrs.lazyRender !== undefined;
      var keepAlive = attrs.keepAlive !== undefined;
      var loaded = false;
      var _attrs$duration = attrs.duration,
        duration = _attrs$duration === void 0 ? 0.1 : _attrs$duration,
        _attrs$timingFunction = attrs.timingFunction,
        timingFunction = _attrs$timingFunction === void 0 ? 'ease-in-out' : _attrs$timingFunction,
        emitOnClose = attrs.emitOnClose,
        onClose = attrs.onClose;
      var closePromise = null;
      var openPromise = null;
      var getHeight = function getHeight() {
        var height = 0;
        var children = element.children();
        for (var i = 0; i < children.length; i += 1) {
          height += children[i].clientHeight;
        }
        return "".concat(height, "px");
      };
      var show = function show() {
        if (closePromise) {
          $timeout.cancel(closePromise);
        }
        if (lazyRender) {
          scope.lazyRender = true;
        }
        scope.loaded = true;
        return $timeout(function () {
          if (openPromise) {
            $timeout.cancel(openPromise);
          }
          element.css({
            overflowY: 'hidden',
            transitionProperty: 'height',
            transitionDuration: "".concat(duration, "s"),
            transitionTimingFunction: timingFunction,
            height: getHeight()
          });
          openPromise = $timeout(function () {
            return element.css({
              overflowY: 'visible',
              transition: 'none',
              height: 'auto'
            });
          }, duration * 1000);
          return openPromise;
        });
      };
      var hide = function hide() {
        if (openPromise) {
          $timeout.cancel(openPromise);
        }
        element.css({
          overflowY: 'hidden',
          transitionProperty: 'height',
          transitionDuration: "".concat(duration, "s"),
          transitionTimingFunction: timingFunction,
          height: '0px'
        });
        if (emitOnClose || onClose || lazyRender) {
          closePromise = $timeout(function () {
            if (emitOnClose) {
              scope.$emit(emitOnClose, {});
            }
            if (onClose) {
              elementScope.$eval(onClose);
            }
            if (lazyRender && !keepAlive) {
              scope.lazyRender = false;
            }
            if (loaded) {
              scope.loaded = false;
            }
          }, duration * 1000);
          return closePromise;
        }
        return null; // just to make eslint happy
      };
      return scope.$watch('expanded', function (value) {
        if (value) {
          return $timeout(show);
        }
        if (value != null) {
          element.css({
            height: getHeight()
          });
        }
        return $timeout(hide);
      });
    },
    template: function template(element, attrs) {
      return (// `<div><div ng-transclude ${attrs.lazyRender !== undefined ? 'ng-if="lazyRender"' : ''} ${attrs.keepAlive !== undefined ? 'ng-show="loaded"' : ''}></div></div>`,
        "<div ng-transclude ".concat(attrs.lazyRender !== undefined ? 'ng-if="lazyRender"' : '', " ").concat(attrs.keepAlive !== undefined ? 'ng-show="loaded"' : '', "></div>")
      );
    }
  };
});
angular.module('app').directive('spinner', function ($http) {
  return {
    restrict: 'C',
    link: function link(scope, element) {
      scope.isLoading = function () {
        return $http.pendingRequests.length > 0;
      };
      scope.$watch(scope.isLoading, function (newValue) {
        if (newValue) {
          element.removeClass('ng-hide');
        } else {
          element.addClass('ng-hide');
        }
      });
    }
  };
});
angular.module('app').directive('uploadFile', function ($dialog) {
  return {
    restrict: 'A',
    scope: {
      file: '=uploadFile',
      onUpload: '&'
    },
    link: function link(scope, element, attrs) {
      element.bind('change', function () {
        // we upload only if the user selected a file
        if (element[0].files[0]) {
          var progressBar = document.querySelector(attrs.progressBar);
          var formData = new FormData();
          formData.append('file', element[0].files[0]);
          $.ajax({
            beforeSend: function beforeSend() {
              if (progressBar) {
                progressBar.style.display = 'block';
                progressBar.style.width = '0%';
              }
              scope.file = {
                uploading: true
              };
              scope.$apply();
            },
            xhr: function xhr() {
              var xhr = new window.XMLHttpRequest();
              xhr.upload.addEventListener('progress', function (e) {
                if (e.lengthComputable) {
                  progressBar.style.width = "".concat(e.loaded / e.total * 100, "%");
                }
              }, false);
              return xhr;
            },
            url: attrs.postUrl,
            processData: false,
            contentType: false,
            type: 'post',
            data: formData
          }).done(function (response) {
            scope.file = response.file;
            scope.onUpload({
              file: scope.file
            });
          }).fail(function (response) {
            if (response.status !== 422) {
              $dialog.error('Whoops, looks like something went wrong.');
            } else {
              var values = Object.values(response.responseJSON);
              if (values[0][0]) {
                $dialog.error(values[0][0]);
              }
            }
            scope.file = null;
          }).always(function () {
            progressBar.style.display = 'none';
            progressBar.style.width = '0%';
            scope.$apply();

            // we reset this on purpose, otherwise we will not be able to "re-select" the same file for the second time
            element[0].value = '';
          });
        }
      });
    }
  };
});
angular.module('app').filter('mailgunState', function () {
  return function (input) {
    switch (input) {
      case 'delivered':
        return 'Delivered';
      case 'permanent_fail':
      case 'temporary_fail':
        return 'Failed';
      case 'unsubscribed':
        return 'Unsubscribed';
      case 'opened':
        return 'Opened';
      case 'clicked':
        return 'Clicked';
      case 'complained':
        return 'Complained';
      default:
        return input;
    }
  };
});
angular.module('app').filter('momentAt', function () {
  var at = function at(input) {
    return moment(input).calendar(null, {
      sameDay: 'HH:mm',
      nextDay: '[Tomorrow]',
      nextWeek: '[Next] dddd',
      lastDay: 'DD/MM/YY HH:mm',
      lastWeek: 'DD/MM/YY HH:mm',
      sameElse: 'DD/MM/YY HH:mm'
    });
  };
  return at;
});
angular.module('app').filter('momentFromNow', function () {
  var fromNow = function fromNow(input) {
    return moment().startOf('day') < input ? moment(input).fromNow() : moment(input).calendar(null, {
      sameDay: '[Today]',
      nextDay: '[Tomorrow]',
      nextWeek: '[Next] dddd',
      lastDay: '[Yesterday]',
      lastWeek: 'dddd',
      sameElse: 'DD/MM/YYYY'
    });
  };
  fromNow.$stateful = true;
  return fromNow;
});
angular.module('app').filter('mongoDate', function () {
  return function (input) {
    return input && input['$date'] && input['$date']['$numberLong'] ? input['$date']['$numberLong'] : null;
  };
});
angular.module('app').filter('photoUrl', function () {
  return function (photo, id, size) {
    if (!photo || !photo.uuid) {
      return null;
    }
    if (!size) {
      return "media/users/".concat(id, "/avatar.jpg");
    }
    if (!photo.resized) {
      return "/media/users/".concat(id, "/").concat(photo.uuid, "/").concat(photo.name);
    }
    return "/media/users/".concat(id, "/").concat(photo.uuid, "/").concat(size, ".jpg");
  };
});
angular.module('app').filter('unsafe', function ($sce) {
  return $sce.trustAsHtml;
});
angular.module('app').factory('appCacheFactory', function ($cacheFactory) {
  return $cacheFactory('app-cache');
});
angular.module('app').factory('authInterceptor', function ($q, $rootScope) {
  return {
    responseError: function responseError(response) {
      if (response.status === 401) {
        $rootScope.$broadcast('AUTH_REQUIRED');
      }
      return $q.reject(response);
    }
  };
});
angular.module('app').factory('authFactory', function ($http, $env) {
  function url() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return [$env.API, 'user'].concat(args).join('/');
  }
  return {
    logOut: function logOut() {
      return $http.get(url('log-out'));
    },
    getUser: function getUser() {
      return $http.get(url()).then(function (response) {
        return response.data;
      });
    },
    updateUser: function updateUser(data) {
      return $http.put(url(), data).then(function (response) {
        return response.data;
      });
    }
  };
});
angular.module('app').factory('$dialog', function ($uibModal, $document) {
  function parentElem(parentSelector) {
    return parentSelector ? angular.element($document[0].querySelector(parentSelector)) : undefined;
  }
  function alert(title, body, options, parentSelector) {
    return $uibModal.open({
      animation: true,
      // ariaLabelledBy: 'modal-title',
      // ariaDescribedBy: 'modal-body',
      templateUrl: 'dialog-modal/alert-modal.html',
      appendTo: parentElem(parentSelector),
      controller: ['$scope', function ($scope) {
        $scope.title = title;
        $scope.body = body;
        $scope.options = options || {};
      }],
      windowClass: "dialog ".concat(options.windowClass || 'info')
    });
  }
  function confirm(title, body, options, parentSelector) {
    return $uibModal.open({
      animation: true,
      templateUrl: 'dialog-modal/confirm-modal.html',
      appendTo: parentElem(parentSelector),
      controller: ['$scope', function ($scope) {
        $scope.title = title;
        $scope.body = body;
        $scope.options = options || {};
      }],
      windowClass: "dialog ".concat(options.windowClass || 'primary')
    });
  }
  function prompt(title, label, value, required, placeholder, options, parentSelector) {
    return $uibModal.open({
      animation: true,
      backdrop: 'static',
      templateUrl: 'dialog-modal/prompt-modal.html',
      appendTo: parentElem(parentSelector),
      controller: ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
        $scope.title = title;
        $scope.label = label;
        $scope.value = value;
        $scope.required = required;
        $scope.placeholder = placeholder;
        $scope.options = options || {};
        $scope.submit = function () {
          if (!$scope.form.$invalid) {
            $uibModalInstance.close($scope.value);
          }
        };
      }],
      windowClass: "dialog ".concat(options.windowClass || '')
    });
  }
  function promptText(title, label, value, required, placeholder, options, parentSelector) {
    return $uibModal.open({
      animation: true,
      backdrop: 'static',
      templateUrl: 'dialog-modal/prompt-text-modal.html',
      appendTo: parentElem(parentSelector),
      controller: ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
        $scope.title = title;
        $scope.label = label;
        $scope.value = value;
        $scope.required = required;
        $scope.placeholder = placeholder;
        $scope.options = options || {};
        $scope.submit = function () {
          if (!$scope.form.$invalid) {
            $uibModalInstance.close($scope.value);
          }
        };
      }],
      windowClass: "dialog ".concat(options.windowClass || '')
    });
  }
  function error(msg) {
    return alert('Error', "<p>".concat(msg, "</p>"), {
      windowClass: 'danger',
      closeBtnClass: 'btn-danger'
    });
  }
  function success(msg) {
    return alert('Success', "<p>".concat(msg, "</p>"), {
      windowClass: 'success',
      closeBtnClass: 'btn-success'
    });
  }
  function onError(response) {
    var msg = 'Whoops, looks like something went wrong.';
    if (response && response.status === 422 && response.data && response.data.errors) {
      var _Object$values = Object.values(response.data.errors);
      var _Object$values2 = _slicedToArray(_Object$values, 1);
      var _Object$values2$ = _slicedToArray(_Object$values2[0], 1);
      msg = _Object$values2$[0];
    }
    return error(msg);
  }
  return {
    alert: alert,
    confirm: confirm,
    prompt: prompt,
    promptText: promptText,
    error: error,
    success: success,
    onError: onError
  };
}).run(['$templateCache', function ($templateCache) {
  $templateCache.put('dialog-modal/alert-modal.html', "\n      <div class=\"modal-header\">\n        <h5 class=\"modal-title\">{{ title || '&nbsp;' }}</h5>\n        <button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" data-dismiss=\"modal\" aria-label=\"Close\" tabindex=\"-1\">\n          <span aria-hidden=\"true\">\xD7</span>\n        </button>\n      </div>\n      <div class=\"modal-body\" ng-bind-html=\"body | unsafe\"></div>\n      <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn\" ng-click=\"$dismiss()\" data-dismiss=\"modal\" ng-class=\"options.closeBtnClass || 'btn-primary'\">\n          {{ options.closeBtnText || 'Close' }}\n        </button>\n      </div>\n    ");
  $templateCache.put('dialog-modal/confirm-modal.html', "\n      <div class=\"modal-header\">\n        <h5 class=\"modal-title\">{{ title || '&nbsp;' }}</h5>\n        <button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" data-dismiss=\"modal\" aria-label=\"Close\" tabindex=\"-1\">\n          <span aria-hidden=\"true\">\xD7</span>\n        </button>\n      </div>\n      <div class=\"modal-body\" ng-bind-html=\"body | unsafe\"></div>\n      <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn\" ng-click=\"$dismiss()\" data-dismiss=\"modal\" ng-class=\"options.cancelBtnClass || 'btn-outline-primary'\">\n          {{ options.cancelBtnText || 'Cancel' }}\n        </button><!-- do not delete --><button type=\"button\" class=\"btn\" ng-click=\"$close()\" ng-class=\"options.okBtnClass || 'btn-primary'\">\n          {{ options.okBtnText || 'OK' }}\n        </button>\n      </div>\n    ");
  $templateCache.put('dialog-modal/prompt-modal.html', "\n      <form name=\"form\" ng-submit=\"submit()\" novalidate autocomplete=\"off\">\n        <div class=\"modal-header\">\n          <h5 class=\"modal-title\">{{ title || '&nbsp;' }}</h5>\n          <button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" data-dismiss=\"modal\" aria-label=\"Close\" tabindex=\"-1\">\n            <span aria-hidden=\"true\">\xD7</span>\n          </button>\n        </div>\n        <div class=\"modal-body\">\n          <label ng-if=\"label\">{{ label }} <span class=\"required\" ng-show=\"required\">*</span></label>\n          <input type=\"text\" name=\"value\" class=\"form-control\" ng-model=\"value\" ng-required=\"required\" placeholder=\"{{ placeholder || '' }}\">\n          <div ng-messages=\"form.value.$error\" ng-if=\"form.$submitted\">\n            <div ng-message=\"required\">This field is required</div>\n          </div>\n        </div>\n        <div class=\"modal-footer\">\n          <button type=\"button\" class=\"btn\" ng-click=\"$dismiss()\" data-dismiss=\"modal\" ng-class=\"options.cancelBtnClass || 'btn-outline-primary'\">\n            {{ options.cancelBtnText || 'Cancel' }}\n          </button><!-- do not delete --><button type=\"submit\" class=\"btn\" ng-class=\"options.okBtnClass || 'btn-primary'\">\n            {{ options.okBtnText || 'OK' }}\n          </button>\n        </div>\n      </form>\n   ");
  $templateCache.put('dialog-modal/prompt-text-modal.html', "\n      <form name=\"form\" ng-submit=\"submit()\" novalidate autocomplete=\"off\">\n        <div class=\"modal-header\">\n          <h5 class=\"modal-title\">{{ title || '&nbsp;' }}</h5>\n          <button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" data-dismiss=\"modal\" aria-label=\"Close\" tabindex=\"-1\">\n            <span aria-hidden=\"true\">\xD7</span>\n          </button>\n        </div>\n        <div class=\"modal-body\">\n          <label ng-if=\"label\">{{ label }} <span class=\"required\" ng-show=\"required\">*</span></label>\n\n          <textarea name=\"value\" class=\"form-control\" ng-model=\"value\" ng-required=\"required\" placeholder=\"{{ placeholder || '' }}\"></textarea>\n          <div ng-messages=\"form.value.$error\" ng-if=\"form.$submitted\">\n            <div ng-message=\"required\">This field is required</div>\n          </div>\n        </div>\n        <div class=\"modal-footer\">\n          <button type=\"button\" class=\"btn\" ng-click=\"$dismiss()\" data-dismiss=\"modal\" ng-class=\"options.cancelBtnClass || 'btn-outline-primary'\">\n            {{ options.cancelBtnText || 'Cancel' }}\n          </button><!-- do not delete --><button type=\"submit\" class=\"btn\" ng-class=\"options.okBtnClass || 'btn-primary'\">\n            {{ options.okBtnText || 'OK' }}\n          </button>\n        </div>\n      </form>\n   ");
}]);
angular.module('app').factory('$localStorage', function ($window) {
  return {
    set: function set(key, value) {
      $window.localStorage[key] = value;
    },
    get: function get(key, defaultValue) {
      return $window.localStorage[key] || defaultValue;
    },
    setObject: function setObject(key, value) {
      $window.localStorage[key] = JSON.stringify(value);
    },
    getObject: function getObject(key) {
      try {
        return JSON.parse($window.localStorage[key]);
      } catch (error) {
        return null;
      }
    },
    getObjectProperty: function getObjectProperty(key, property) {
      try {
        return JSON.parse($window.localStorage[key])[property];
      } catch (error) {
        return undefined;
      }
    },
    isSet: function isSet(key) {
      return typeof $window.localStorage[key] !== 'undefined';
    },
    unset: function unset(key) {
      delete $window.localStorage[key];
    }
  };
});
angular.module('app').factory('lookupFactory', function ($http) {
  return {
    findCompanies: function findCompanies(keyword) {
      return $http.get('/api/v3/find/companies', {
        params: {
          starts_with: keyword
        }
      }).then(function (response) {
        return response.data;
      });
    }
  };
});